import { useSessionStorage } from '../hooks/useSessionStorage';
import { useCallback } from 'react';
import { useProfilesLocalStorage } from '../ProfilesLocalStorageContext';
import { isProfileIconImage } from '../typeGuards';
import { useAuthContext } from '../contexts/AuthContext/AuthContext';

const LOGIN_API_ERROR_SESSION_STORAGE_KEY = 'login_api_has_errored';

const useLoginApiError = () => {
  const { setUser } = useAuthContext();

  const [loginApiHasErrored, setLoginApiHasErrored] =
    useSessionStorage<boolean>(LOGIN_API_ERROR_SESSION_STORAGE_KEY, false);
  const { profiles } = useProfilesLocalStorage();

  const flagLoginApiErrorForSession = useCallback(() => {
    setLoginApiHasErrored(true);
  }, [setLoginApiHasErrored]);

  const recoverFromLoginApiServerError5xx = useCallback(
    (sessionCookie: string | undefined) => {
      /* We might have a session cookie from request, if login-api errored via our Express application server.
       * We assume session is still valid and try to set login.user state from localStorage.
       */
      const profile = profiles.find(p => p.cookie === sessionCookie);
      if (profile) {
        setUser({
          username: profile.displayName || profile.username || '',
          nick: profile.nick ? profile.nick : null,
          initials: isProfileIconImage(profile.icon) ? '' : profile.icon.value,
          userId: profile.userId,
          verifications: [],
          nickUpdatedAt: null,
          latestTermsOfServiceAccepted: true,
          isSubAccount: profile.parentId !== null,
          consent: profile.consent,
        });
      }
    },

    [profiles, setUser]
  );

  return {
    loginApiHasErrored,
    flagLoginApiErrorForSession,
    recoverFromLoginApiServerError5xx,
  };
};

export default useLoginApiError;
